import type {LoadingStates} from '@Utils/loading.util';

export interface PublishingLoadingStates {
  publishingLoadingState: LoadingStates;
  loadingPublishingOption: PublishingOption | null;
}

export interface PublishingOptionsProps {
  chatId: string;
  hashedId: string;
  loadingStates: PublishingLoadingStates;
  publishToSocialMedia: () => Promise<void>;
  promoteAsEvent: () => Promise<void>;
  publishAsEmailCampaign: () => Promise<void>;
  removeLastItemBottomMargin?: boolean;
  excludedOptions?: PublishingOption[];
}

export enum PublishingOption {
  PUBLISH_TO_SOCIAL_MEDIA = 'publish_to_social_media',
  PROMOTE_AS_EVENT = 'promote_as_event',
  PUBLISH_AS_EMAIL_CAMPAIGN = 'publish_as_email_campaign',
}
